const commonState = {
  agentBillProcessStatus: [], // 合作商账单流程状态
  agentType: [], // 合作商类型
  agentBillStatus: [], // 合作商账单状态
  partners: [], // 合作商
  businessLine: [], // 业务线
  authRegions: [] // rigion
}

const commonMutations = {
  mu_agentBillProcessStatus(state, val) {
    state.agentBillProcessStatus = val
  },
  mu_agentType(state, val) {
    state.agentType = val
  },
  mu_agentBillStatus(state, val) {
    state.agentBillStatus = val
  },
  mu_authRegions(state, val) {
    state.authRegions = val
  },
  mu_partners(state, val) {
    state.partners = val
  },
  mu_businessLine(state, val) {
    state.businessLine = val
  },
}

const commonActions = {

}

export {
  commonState,
  commonMutations,
  commonActions,
}
